module.exports = __webpack_public_path__ + "static/feitosa-e-novais-987fbbd68a48e96410059c49c0ef8613.png";